import { ArrayValue, RecordValue, StringValue } from '@coveo/bueno';
import { requiredEmptyAllowedString, requiredNonEmptyString, } from '../../utils/validate-payload.js';
export const staticFilterIdSchema = requiredNonEmptyString;
export const staticFilterValueSchema = new RecordValue({
    options: { required: true },
    values: {
        caption: requiredEmptyAllowedString,
        expression: requiredEmptyAllowedString,
        state: new StringValue({
            constrainTo: ['idle', 'selected', 'excluded'],
        }),
    },
});
export const staticFilterValuesSchema = new ArrayValue({
    required: true,
    each: staticFilterValueSchema,
});
